import React from 'react'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function SingleFacilitatorData (props) {

  return (
    <div>
      <ReactTableFixedColumns  
                data={props.data || []} 
                columns={[
                    {
                        id: "first_name",
                        Header: "First Name",
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                        accessor: "sFirstName",
                        // width: 350,	
                        style:{'whiteSpace': 'unset'},
                        fixed:"left"
                    },
                    {
                        id: "last_name",
                        Header: "Last Name",
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                        accessor: "sLastName",
                        // width: 350,	
                        style:{'whiteSpace': 'unset'},
                        fixed:"left"
                    },
                    {
                        id: "email_address",
                        Header: "Email Address",
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                        accessor: "sEmailAddress",
                        // width: 350,	
                        style:{'whiteSpace': 'unset'},
                        fixed:"left"
                    },
                    {
                        id: "contact_number",
                        Header: "Contact Number",
                        headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
                        accessor: "sContactNumber",
                        // width: 350,	
                        style:{'whiteSpace': 'unset'},
                        // fixed:"left"
                    },
                ]}

                // pageSize={props.data.length}
                sortable={false}
                showPagination={true}
                style={{overflowY: "auto",height: "445px"}}	
                className="-striped"
            />
    </div>
  )
}
